export default "__VITE_ASSET__Dc5PRljN__"